"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var Config = __importStar(require("../../Config"));
var ApiUtil = __importStar(require("../../Utils/ApiUtil"));
var ClipboardUtil = __importStar(require("../../Utils/ClipboardUtil"));
function FileUploadModal(props) {
  var visible = props.visible,
    setVisible = props.setVisible;
  return react_1.default.createElement(antd_1.Modal, {
    title: null,
    footer: null,
    bodyStyle: {
      padding: 0
    },
    width: 450,
    visible: visible,
    onOk: function () {
      return setVisible(false);
    },
    onCancel: function () {
      return setVisible(false);
    },
    destroyOnClose: true
  }, react_1.default.createElement(FileUploadContent, {
    preview: props.preview,
    accept: props.accept
  }));
}
exports.default = FileUploadModal;
function FileUploadContent(props) {
  var _a = props.preview,
    preview = _a === void 0 ? true : _a,
    _b = props.accept,
    accept = _b === void 0 ? 'image/*' : _b;
  var user = reconnect_js_1.useOutlet('user')[0];
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var _c = react_1.default.useState(null),
    url = _c[0],
    setUrl = _c[1];
  var _d = react_1.default.useState(null),
    name = _d[0],
    setName = _d[1];
  var _e = react_1.default.useState(null),
    expectedUrl = _e[0],
    setExpectedUrl = _e[1];
  var fileInputRef = react_1.default.useRef(null);
  var _f = react_1.default.useState(0),
    step = _f[0],
    setStep = _f[1];
  function onFileSelected() {
    var _a;
    if ((_a = fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) === null || _a === void 0 ? void 0 : _a.files) {
      var selectedFile = fileInputRef.current.files[0];
      console.log(selectedFile);
      if (!selectedFile) {
        setUrl(null);
      } else {
        var objUrl = URL.createObjectURL(selectedFile);
        console.log(objUrl);
        setUrl(objUrl);
        setName(selectedFile.name);
        setStep(1);
      }
    }
  }
  function uploadFile() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var selectedFile, resp, expected, fields, url_1, formData, key, uploadResp, ex_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!((_a = fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) === null || _a === void 0 ? void 0 : _a.files)) {
              return [2 /*return*/];
            }
            selectedFile = fileInputRef.current.files[0];
            if (!(user && selectedFile)) return [3 /*break*/, 6];
            actions.setLoading(true);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 4,, 5]);
            return [4 /*yield*/, ApiUtil.req(Config.get().storageHost + "/storage/presigned/url?client_id=" + Config.get().clientId + "&token=" + user.token, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                acl: 'public-read',
                'Content-Type': selectedFile.type,
                key: selectedFile.name.split('.')[0],
                unique_key: true
              }
            })];
          case 2:
            resp = _b.sent();
            expected = resp.expected, fields = resp.fields, url_1 = resp.url;
            formData = new FormData();
            for (key in fields) {
              formData.set(key, fields[key]);
            }
            formData.set('file', selectedFile);
            return [4 /*yield*/, fetch(url_1, {
              method: 'POST',
              body: formData
            })];
          case 3:
            uploadResp = _b.sent();
            if (uploadResp.status.toString()[0] !== '2') {
              throw uploadResp;
            }
            setExpectedUrl(expected);
            setStep(2);
            return [3 /*break*/, 5];
          case 4:
            ex_1 = _b.sent();
            console.warn(ex_1);
            alert('上傳失敗: 請稍後再試');
            return [3 /*break*/, 5];
          case 5:
            actions.setLoading(false);
            _b.label = 6;
          case 6:
            return [2 /*return*/];
        }
      });
    });
  }
  var stepElem = react_1.default.createElement(antd_1.Steps, {
    direction: "horizontal",
    type: "navigation",
    responsive: false,
    current: step,
    style: {
      marginBottom: 20
    }
  }, react_1.default.createElement(antd_1.Steps.Step, {
    title: "\u9078\u64C7\u6A94\u6848"
  }), react_1.default.createElement(antd_1.Steps.Step, {
    title: "\u4E0A\u50B3\u6A94\u6848"
  }), react_1.default.createElement(antd_1.Steps.Step, {
    title: "\u62F7\u8C9D\u9023\u7D50"
  }));
  return react_1.default.createElement(Wrapper, null, stepElem, react_1.default.createElement("input", {
    type: "file",
    accept: accept,
    ref: fileInputRef,
    onChange: onFileSelected,
    style: {
      display: step === 0 ? 'block' : 'none'
    }
  }), step === 1 && url && react_1.default.createElement(react_1.default.Fragment, null, preview ? react_1.default.createElement("img", {
    src: url,
    className: "preview",
    alt: "preview"
  }) : react_1.default.createElement("div", null, name), react_1.default.createElement("div", {
    className: "action-bar"
  }, react_1.default.createElement(antd_1.Button, {
    onClick: function () {
      setUrl(null);
      setStep(0);
    }
  }, "\u91CD\u9078\u6A94\u6848"), react_1.default.createElement(antd_1.Button, {
    type: "primary",
    onClick: uploadFile
  }, "\u4E0A\u50B3"))), step === 2 && expectedUrl && react_1.default.createElement(react_1.default.Fragment, null, preview && react_1.default.createElement("img", {
    src: expectedUrl,
    className: "preview",
    alt: "preview"
  }), react_1.default.createElement("div", {
    id: "rev-upload-expected-url"
  }, expectedUrl), react_1.default.createElement("div", {
    className: "action-bar"
  }, react_1.default.createElement(antd_1.Button, {
    type: "primary",
    onClick: function () {
      ClipboardUtil.copyFromElem('rev-upload-expected-url');
    }
  }, "\u62F7\u8C9D\u7DB2\u5740"))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 40px 20px 20px 20px;\n\n  & > .preview {\n    display: block;\n    width: 200px;\n    height: 200px;\n    object-fit: contain;\n    background-color: #ccc;\n    overflow: hidden;\n  }\n\n  & > .action-bar {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    & > * {\n      margin-left: 10px;\n    }\n  }\n"], ["\n  padding: 40px 20px 20px 20px;\n\n  & > .preview {\n    display: block;\n    width: 200px;\n    height: 200px;\n    object-fit: contain;\n    background-color: #ccc;\n    overflow: hidden;\n  }\n\n  & > .action-bar {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    & > * {\n      margin-left: 10px;\n    }\n  }\n"])));
var templateObject_1;